import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ko from "./locales/ko.json";

// Languages the storefront ships translations for. Which of these customers may
// actually pick (and the site default) is decided by the super-admin — see
// LanguageContext, which reads /i18n/status from the backend.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
    },
    fallbackLng: "en",
    load: "languageOnly", // "ko-KR" → "ko"
    supportedLngs: ["en", "ko"],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "fmart_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
